import { css } from "@emotion/react";
import React from "react";
import useD3 from "../util/use-d3";

import { axisBottom, axisLeft, min, max, format, line, extent, scaleLinear, scaleUtc } from "d3";

const margin = { top: 1, right: 0, bottom: 1, left: 0 };
export default function SparkineChart({ data, index, prevIndex, dateIndex }) {
    const [elemRef, dimensionRef] = useD3(
        (svg, { width, height }) => {
            if (!data) return;

            const w = width - margin.left - margin.right,
                h = height - margin.top - margin.bottom;

            const chartArea = svg.select(".chart-area");
            chartArea.attr("transform", `translate(${margin.left},${margin.top})`);

            const xScale = scaleUtc()
                .domain(extent(data, d => new Date(d[dateIndex])))
                .range([0, w]);
            const xAxis = axisBottom(xScale).ticks(7);
            svg.select(".x-axis").attr("transform", `translate(${margin.left},${margin.top + h})`);

            const yScale = scaleLinear()
                .domain([
                    min(data, d => min([d[index], d[prevIndex]])),
                    max(data, d => max([d[index], d[prevIndex]]))
                ])
                .range([h, 0]);
            const yAxis = axisLeft(yScale)
                .ticks(2)
                .tickFormat(format("~s"));
            svg.select(".y-axis").attr("transform", `translate(${margin.left},${margin.top})`);

            const currentLine = line()
                .x(d => xScale(new Date(d[dateIndex])))
                .y(d => yScale(d[index]));

            const prevLine = line()
                .x(d => xScale(new Date(d[dateIndex])))
                .y(d => yScale(d[prevIndex]));

            if (prevIndex) {
                chartArea
                    .selectAll(".prev-line")
                    .datum(data)
                    .join("path")
                    .attr("class", "prev-line")
                    .attr("fill", "none")
                    .attr("stroke", "#aaa")
                    .attr("stroke-width", 1)
                    .attr("stroke-dasharray", "3 1")
                    .attr("d", prevLine);
            }
            chartArea
                .selectAll(".line")
                .datum(data)
                .join("path")
                .attr("class", "line")
                .attr("fill", "none")
                .attr("stroke", "#3690b4")
                .attr("stroke-width", 3)
                .attr("d", currentLine);

            svg.select(".x-axis").remove();
            svg.select(".y-axis").remove();
        },
        [data, index, prevIndex]
    );
    return (
        <div
            ref={dimensionRef}
            style={{
                margin: "0.25rem 0",
                height: "3.5rem",
                width: "100%"
            }}
        >
            <svg
                ref={elemRef}
                css={css`
                    border: none;
                    display: block;
                    width: 100%;
                    height: 3.5rem;
                    & .axis {
                        color: #777;
                        shape-rendering: crispEdges;
                    }
                `}
            >
                <g className="chart-area">
                    <path className="prev-line" />
                    <path className="line" />
                    <g className="gridlines" />
                </g>
                <g className="axis y-axis" />
                <g className="axis x-axis" />
            </svg>
        </div>
    );
}
